import { combineReducers, configureStore } from "@reduxjs/toolkit";
import apiReducer from "../reducer/apiReducer";
import authReducer from "../reducer/authReducer";
import userReducer from "../reducer/userReducer";
import gameReducer from "../reducer/gameReducer";
import reservationReducer from "../reducer/userReservationReducer";
import calenderReducer from "../reducer/calenderReducer";
import stepperReducer from "../reducer/stepperReducer";
import rootReducer from '../reducer/rootReducer'
import chatReducer from '../reducer/chatReducer'

const combineReducer = combineReducers({
  user: userReducer,
  auth: authReducer,
  api: apiReducer,
  reservation: reservationReducer,
  game: gameReducer,
  calendar: calenderReducer,
  stepper: stepperReducer,
  root: rootReducer,
  chat: chatReducer
})

const appReducer=(state,action)=>{
  //Reset all reducer to initial state
  if(action.type==='RESET_TO_INITIAL'){
    state={};
  }
  return combineReducer(state,action);
}

export const store = configureStore({
  reducer: appReducer
});

export default store;
export const { dispatch } = store;